import PropTypes, { InferProps } from 'prop-types';

export const BillingDetailsDefaultPropTypes = {
  billingAddress: PropTypes.string,
  billingAddress2: PropTypes.string,
  billingState: PropTypes.string,
  billingCity: PropTypes.string,
  billingZip: PropTypes.string,
  billingCountry: PropTypes.string,
  billingEmail: PropTypes.string,
};

export const CommonPaymentElementPropTypes = {
  lang: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  onLoadStart: PropTypes.func,
  onLoadEnd: PropTypes.func,
  onSuccess: PropTypes.func,
  onError: PropTypes.func,
  onSubmit: PropTypes.func,
  onPaymentToken: PropTypes.func,
  guest: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    email: PropTypes.string,
    billingDetails: PropTypes.shape(BillingDetailsDefaultPropTypes),
  }),
};

export type CommonPaymentElementProps = InferProps<typeof CommonPaymentElementPropTypes>;
